import CompanyIntegrationsTable from '@/ui/components/companySettings/components/CompanyIntegrationsTable';
import CompanyWebhooksTable from '@/ui/components/companySettings/components/CompanyWebhooksTable';
import { AnchorButton, Card } from '@payaca/ambrosia';
import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';
import { Link } from 'react-router-dom';
import { PermissionGuard } from '../permissionGuard/PermissionGuard';

type Props = {
  readOnly?: boolean;
};
const CompanySettingsIntegrations = (props: Props) => {
  const { readOnly } = props;

  return (
    <>
      <Card sizeVariant="lg">
        <Card.Body>
          <h2 className="mb-2">Integrations</h2>
          <p className="mb-4">
            For our partner integrations see the{' '}
            <AnchorButton
              as={Link}
              to="/companySettings/integrations-data/connections"
              variant="link"
            >
              Connections
            </AnchorButton>{' '}
            page.
          </p>

          <div className="space-y-4">
            <PermissionGuard
              renderIfHasPermissions={[AccountsPermissions.MANAGE_API_KEYS]}
            >
              <CompanyIntegrationsTable readOnly={readOnly} />
            </PermissionGuard>

            <PermissionGuard
              renderIfHasPermissions={[AccountsPermissions.MANAGE_WEBHOOKS]}
            >
              <CompanyWebhooksTable readOnly={readOnly} />
            </PermissionGuard>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default CompanySettingsIntegrations;
